import React, { Component } from 'react';
import './index.css'
import Register from './register'
import Record from './record'
import cookie from 'react-cookies'

export default class componentName extends Component {
  state = {
    show: 1,
    innerWidth: window.innerWidth,
  }

  componentDidMount=()=>{
    if(cookie.load('type')=='app'){
      this.setState({
        show:2
      })
    }
  }
  
  tabsClick=(state)=>{
    this.setState({
      show:state
    })
  }

  render() {
    const { show, innerWidth } = this.state
    return (
      <div className="index">
        <div className="index-head">
          <img src={require('./../../images/01.png')} alt="" />
        </div>
        <div className="index-main">
          <div className="index-main-top">
            <div className="index-tabs">
              <div className="index-tabs-cont">
                {
                  cookie.load('type')!='app'?(<div className={show===1?'index-tabs-title':''} onClick={()=>{
                    this.tabsClick(1)
                  }}>登记申请</div>):('')
                }
                <div className={show===2?'index-tabs-title':''} onClick={()=>{
                  this.tabsClick(2)
                }}>申请记录</div>
              </div>
              
              {
                cookie.load('type')!='app'?(<div className="index-tabs-bar" style={{left:show===1? `${innerWidth/4 + 2}px`: `${(innerWidth/4) * 3 - 50}px`}}></div>):(<div className="index-tabs-bar" style={{left:`${(innerWidth/3) +40}px`}}></div>)
              }
              
            </div>
                {show===1?(<Register></Register>):''}
                {show===2?(<Record history={this.props.history}></Record>):''}
          </div>

        </div>

      </div>
    );
  }
}
